import(/* webpackMode: "eager" */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/app/[locale]/register/page.tsx");
